import st_canvas_h5 from './st_canvas.h5'

export default st_canvas_h5